export default {
    h1: {
        fontSize: 6,
    },
    h2: {
        fontSize: 4,
    },
    h3: {
        fontSize: 3,
    },
    h4: {
        fontSize: 2,
    },
    h5: {
        fontSize: 1,
    },
};
